import { ValidatorFn, FormControl } from '@angular/forms';

// corsss multipel fields validation sample
// comes from https://medium.com/@realTomaszKula/angular-cross-field-validation-d94e0d063b61

// please also see https://dzone.com/articles/how-to-do-conditional-validation-on-valuechanges-m
// for another way
export const MyAwesomeRangeValidator: ValidatorFn = (fc: FormControl) => {

    const start = fc.parent.get('rangeStart').value;
    const end = fc.parent.get('rangeEnd').value;
    if (start === '' || end === '') {
        return null;
    }
    const x = Number(start);
    const y = Number(end);

    if (x < y) {
        return null;
    } else {
        return { rangeIsIncorrect: true };
    }

};
